(() => {
  'use strict';

  const STORAGE_KEY = 'shopify_wishlist';

  function getWishlist() {
    try {
      const data = localStorage.getItem(STORAGE_KEY);
      return data ? JSON.parse(data) : [];
    } catch (error) {
      console.error('Wishlist storage error:', error);
      return [];
    }
  }

  function saveWishlist(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    updateAllButtons();
    updateWishlistCount();
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { items, count: items.length } }));
  }

  function isInWishlist(handle) { return getWishlist().includes(handle); }
  function addToWishlist(handle) { const wishlist = getWishlist(); if (!wishlist.includes(handle)) { wishlist.push(handle); saveWishlist(wishlist); } }
  function removeFromWishlist(handle) { saveWishlist(getWishlist().filter((item) => item !== handle)); }
  function toggleWishlist(handle) { isInWishlist(handle) ? removeFromWishlist(handle) : addToWishlist(handle); }

  function updateButton(button) {
    const handle = button.dataset.wishlistHandle;
    if (!handle) return;
    const active = isInWishlist(handle);
    button.classList.toggle('is-active', active);
    button.setAttribute('aria-pressed', active ? 'true' : 'false');
    button.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Add to wishlist');
    const outline = button.querySelector('.wishlist-heart-outline');
    const filled = button.querySelector('.wishlist-heart-filled');
    if (outline) outline.style.display = active ? 'none' : '';
    if (filled) filled.style.display = active ? '' : 'none';
  }

  function updateAllButtons() {
    document.querySelectorAll('[data-wishlist-handle]').forEach(updateButton);
    updateWishlistCount();
  }

  function updateWishlistCount() {
    const count = getWishlist().length;
    const headerCount = document.getElementById('wishlist-count');
    if (headerCount) {
      headerCount.textContent = count;
      headerCount.style.display = count > 0 ? 'flex' : 'none';
    }
    const pageCount = document.getElementById('wishlist-page-count');
    if (pageCount) pageCount.textContent = `${count} ${count === 1 ? 'item' : 'items'}`;
    if (count === 0) {
      const emptyState = document.getElementById('wishlist-empty');
      if (emptyState) emptyState.hidden = false;
    }
  }

  document.addEventListener('click', function (event) {
    const button = event.target.closest('.wishlist-button[data-wishlist-handle]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    const handle = button.dataset.wishlistHandle;
    if (!handle) return;
    const wishlistProduct = button.closest('[data-wishlist-product]');
    if (wishlistProduct) {
      removeFromWishlist(handle);
      wishlistProduct.remove();
      return;
    }
    toggleWishlist(handle);
  }, true);

  document.addEventListener('DOMContentLoaded', updateAllButtons);
  document.addEventListener('shopify:section:load', updateAllButtons);

  window.ShopifyWishlist = { getWishlist, isInWishlist, addToWishlist, removeFromWishlist, toggleWishlist, updateAllButtons, updateWishlistCount };
})();